export default __webpack_public_path__ + "static/media/getStarted.6c62d4ab.png";